import { render } from "./SupplierUsers.vue?vue&type=template&id=81d9cb3c&ts=true"
import script from "./SupplierUsers.ts?vue&type=script&lang=ts"
export * from "./SupplierUsers.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__